import React from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuthContext } from '@contexts/AuthContext'
import Layout from '@components/layout/Layout'
import { useReadiness } from '@/hooks/useReadiness'
import BootScreen from '@/components/boot/BootScreen'
import { CRITICAL_SERVICES } from '@/config/routeServices'

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuthContext()
  const location = useLocation()

  // System-wide boot: check ALL critical services on any protected route
  // This ensures the entire platform wakes up together, like a computer resuming from sleep
  const {
    ready: servicesReady,
    services,
    estimatedSeconds,
    isTimedOut,
  } = useReadiness({
    requiredServices: CRITICAL_SERVICES,
    enabled: isAuthenticated && !isLoading,
  })

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress size={40} />
      </Box>
    )
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Show boot screen while platform is waking up
  if (!servicesReady) {
    return (
      <BootScreen
        services={services}
        estimatedSeconds={estimatedSeconds}
        username={user?.username}
        isTimedOut={isTimedOut}
      />
    )
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export default ProtectedRoute